
import Vue from 'vue';
import { TransformedModule } from '~/transforms/transformModules';
import { TransformedRegularPage } from '~/transforms/transformPages';

export default Vue.extend({
  name: 'page',
  props: {
    modules: {
      type: Array<TransformedModule>,
      required: true,
    },
    pageData: {
      type: Object as () => TransformedRegularPage,
      required: true,
    },
  },
});
